import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { HttpService } from "../../components/services/HttpService";
import { DocumentConstants } from "../types/DocumentConstants";
import { DocumentActions } from "../actions/DocumentAction";
import { BackDropActions } from "../actions/BackDropActions";
import { AlertActions } from "../actions/AlertActions";

function* assignDocRequest(action) {
  try {
    var payload = action.data;
    yield put(BackDropActions.start());
    const response = yield call(HttpService.post, "/document/assign", payload);
    if (response && response.status && "SUCCESS" === response.status) {
      yield put(
        AlertActions.success("Document assigned to patient successfully.")
      );
      yield put(DocumentActions.assignDocToPatientSuccess());
    } else {
      yield put(AlertActions.error(response.result.description));
    }
    yield put(BackDropActions.end());
  } catch (e) {
    yield put(AlertActions.error(e));
    yield put(BackDropActions.end());
  }
}

function* getALLDocRequest(action) {
  try {
    yield put(BackDropActions.start());
    const response = yield call(
      HttpService.get,
      "/document?patientId=" + action.id
    );
    if (response && response.status && "SUCCESS" === response.status) {
      yield put(DocumentActions.getALLDocSuccess(response.result));
    } else {
      yield put(AlertActions.error(response.result.description));
    }
    yield put(BackDropActions.end());
  } catch (e) {
    yield put(AlertActions.error(e));
    yield put(BackDropActions.end());
  }
}

function* getActiveDocRequest(action) {
  try {
    yield put(BackDropActions.start());
    const response = yield call(
      HttpService.get,
      "/document/active?patientId=" + action.id
    );
    if (response && response.status && "SUCCESS" === response.status) {
      yield put(DocumentActions.getActiveDocSuccess(response.result));
    } else {
      yield put(AlertActions.error(response.result.description));
    }
    yield put(BackDropActions.end());
  } catch (e) {
    yield put(AlertActions.error(e));
    yield put(BackDropActions.end());
  }
}

function* getPendingDocRequest(action) {
  try {
    yield put(BackDropActions.start());
    const response = yield call(
      HttpService.get,
      "/document/pending?patientId=" + action.id
    );
    if (response && response.status && "SUCCESS" === response.status) {
      yield put(DocumentActions.getPendingDocSuccess(response.result));
    } else {
      yield put(AlertActions.error(response.result.description));
    }
    yield put(BackDropActions.end());
  } catch (e) {
    yield put(AlertActions.error(e));
    yield put(BackDropActions.end());
  }
}

function* submitDocRequest(action) {
  try {
    var payload = action.data;
    yield put(BackDropActions.start());
    const response = yield call(HttpService.post, "/document/save", payload);
    if (response && response.status && "SUCCESS" === response.status) {
      yield put(AlertActions.success("Document saved successfully."));
      yield put(DocumentActions.submitDocSuccess());
    } else {
      yield put(AlertActions.error(response.result.description));
    }
    yield put(BackDropActions.end());
  } catch (e) {
    yield put(AlertActions.error(e));
    yield put(BackDropActions.end());
  }
}


function* cancelRequest(action) {
  try {
    yield put(BackDropActions.start());
    const response = yield call(
      HttpService.get,
      "/document/cancel/" + action.id
    );
    if (response && response.status && "SUCCESS" === response.status) {
      yield put(DocumentActions.cancelSuccess());
      yield put(AlertActions.success("Document canceled successfully."));
    } else {
      yield put(AlertActions.error(response.result.description));
    }
    yield put(BackDropActions.end());
  } catch (e) {
    yield put(AlertActions.error(e));
    yield put(BackDropActions.end());
  }
}

function* getDocByIdRequest(action) {
  try {
    yield put(BackDropActions.start());
    const response = yield call(HttpService.get, "/document/" + action.id);
    if (response && response.status && "SUCCESS" === response.status) {
      yield put(DocumentActions.getDocByIdSuccess(response.result));
    } else {
      yield put(AlertActions.error(response.result.description));
    }
    yield put(BackDropActions.end());
  } catch (e) {
    yield put(AlertActions.error(e));
    yield put(BackDropActions.end());
  }
}

function* documentSaga() {
  yield takeEvery(DocumentConstants.ASSIGN_DOC_PATIENT_REQUEST,assignDocRequest);
  yield takeEvery(DocumentConstants.GET_ALL_DOC_REQUEST, getALLDocRequest);
  yield takeEvery(DocumentConstants.GET_ACTIVE_DOC_REQUEST,getActiveDocRequest);
  yield takeEvery(DocumentConstants.GET_PENDING_DOC_REQUEST,getPendingDocRequest);
  yield takeEvery(DocumentConstants.SUBMIT_DOC_REQUEST, submitDocRequest);
  yield takeEvery(DocumentConstants.CANCEL_DOC_REQUEST, cancelRequest);
  yield takeEvery(DocumentConstants.GET_DOC_BY_ID_REQUEST, getDocByIdRequest);
}

export default documentSaga;
